/** "X new BTS photos" nudge (2026-02) — in-app only, no email. Purely client-side/localStorage,
 * same pattern already shipped for the Messages unread badge: a photo counts as "new" if its
 * upload timestamp is after the last time this client opened the BTS section for that project
 * ON THIS DEVICE. First visit to a project = everything currently there counts as "new" until
 * they open the section once — identical intended behavior to the Messages badge. */
export function getBtsSeenAt(projectId) {
  return localStorage.getItem(`cp_bts_seen_${projectId}`);
}

export function markBtsSeen(projectId) {
  const now = new Date().toISOString();
  localStorage.setItem(`cp_bts_seen_${projectId}`, now);
  return now;
}

export function countNewBts(timestamps, lastViewedAt) {
  if (!timestamps || timestamps.length === 0) return 0;
  return timestamps.filter((ts) => !lastViewedAt || ts > lastViewedAt).length;
}
